(() => {
  function init(root) {
    if (!root || root.dataset.kffReady) return;
    root.dataset.kffReady = 'true';
    const config = JSON.parse(root.querySelector('[data-kfl-data]').textContent);
    const sizeDialog = root.querySelector('[data-kfl-dialog]');
    function prepareDialog(dialog, openers, closeSelector) {
      if (!dialog) return;
      let opener;
      openers.forEach(button => button.addEventListener('click', () => {
        opener = button;
        if (!dialog.showModal) {
          const fallback = dialog.querySelector('a');
          if (fallback) window.location.assign(fallback.href);
          return;
        }
        dialog.showModal();
        const video = dialog.querySelector('video');
        if (video) {
          if (!video.getAttribute('src')) video.src = video.dataset.videoSrc;
          video.play().catch(() => {});
        }
      }));
      dialog.querySelector(closeSelector).addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        dialog.querySelector('video')?.pause();
        opener?.focus();
      });
    }
    prepareDialog(sizeDialog, root.querySelectorAll('[data-kfl-size]'), '[data-kfl-close]');
    const form = root.querySelector('product-form form');
    if (!form) return;
    const radios = [...form.querySelectorAll('input[data-option-index]')];
    const idInput = form.querySelector('[data-kfl-variant]');
    const button = form.querySelector('[type=submit]');
    const buttonText = button.querySelector('[data-add-to-cart-text]');
    const mainImage = root.querySelector('[data-kfl-product-image]');
    const thumbnails = root.querySelector('[data-kff-thumbnails]');
    let currentColor;
    const options = () => {
      const result = [];
      radios.filter(r => r.checked).forEach(r => { result[Number(r.dataset.optionIndex)] = r.value; });
      return result;
    };
    const variantFor = values => config.variants.find(v => v.options.every((o, i) => o === values[i]));
    const format = (key, color, number) => config.strings[key].replace('__COLOR__', color).replace('__NUMBER__', number);
    function setImage(src, alt) {
      if (!mainImage) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = src;
      mainImage.alt = alt;
    }
    function gallery(color, variant) {
      if (color === currentColor) return;
      currentColor = color;
      let images = config.images.filter(i => i.color?.trim().toLowerCase() === color?.toLowerCase()).slice(0, 3);
      if (!images.length && variant) images = [{src: variant.image, thumb: variant.image}];
      thumbnails.replaceChildren();
      images.forEach((item, i) => {
        const thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.dataset.kffImage = item.src;
        thumb.setAttribute('aria-label', format('imageLabel', color, i + 1));
        thumb.setAttribute('aria-pressed', String(i === 0));
        const image = document.createElement('img');
        image.src = item.thumb; image.alt = ''; image.width = 80; image.height = 80; image.loading = 'lazy';
        thumb.append(image);
        thumb.addEventListener('click', () => {
          setImage(item.src, format('imageAlt', color, i + 1));
          [...thumbnails.children].forEach(t => t.setAttribute('aria-pressed', String(t === thumb)));
        });
        thumbnails.append(thumb);
      });
      if (images.length) setImage(images[0].src, format('imageAlt', color, 1));
    }
    function sync() {
      const selected = options();
      const variant = variantFor(selected);
      idInput.value = variant?.id || '';
      idInput.disabled = !variant;
      button.disabled = !variant?.available;
      button.setAttribute('aria-disabled', String(!variant?.available));
      buttonText.textContent = variant?.available ? `${config.strings.add} • ${variant.price}` : variant ? config.strings.sold : config.strings.unavailable;
      root.querySelector('[data-kfl-stock]').hidden = Boolean(variant?.available);
      if (variant) root.querySelector('[data-kfl-price]').textContent = variant.price_short;
      const color = radios.find(r => r.checked && r.closest('.kfl-colors'))?.value;
      if (color) {
        root.querySelector('[data-kfl-color]').textContent = color;
        gallery(color, variant);
      }
      const small = selected.some(v => v.toLowerCase() === 'small');
      root.querySelector('[data-kfl-fit-head]').textContent = config.strings[small ? 'smallHead' : 'standardHead'];
      root.querySelector('[data-kfl-fit-body]').textContent = config.strings[small ? 'smallBody' : 'standardBody'];
      radios.forEach(r => {
        const candidate = selected.slice(); candidate[Number(r.dataset.optionIndex)] = r.value;
        const unavailable = !variantFor(candidate)?.available;
        r.closest('label').dataset.unavailable = String(unavailable);
        r.setAttribute('aria-label', r.value + (unavailable ? ' — ' + config.strings.sold : ''));
      });
    }
    radios.forEach(r => r.addEventListener('change', sync));
    button.addEventListener('click', event => {
      event.preventDefault();
      if (!variantFor(options())?.available || button.disabled) return;
      document.dispatchEvent(new CustomEvent('theme:cart:add', {detail: {button}, bubbles: false}));
    });
    form.addEventListener('submit', event => {
      if (!variantFor(options())?.available) {
        event.preventDefault(); event.stopImmediatePropagation(); sync();
      }
    }, true);
    const requested = new URLSearchParams(window.location.search).get('variant');
    const requestedVariant = config.variants.find(v => String(v.id) === requested);
    if (requestedVariant && radios.some(r => r.value === requestedVariant.options[0])) radios.forEach(r => { r.checked = requestedVariant.options[Number(r.dataset.optionIndex)] === r.value; });
    sync();
  }
  const start = () => document.querySelectorAll('[data-kff]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-kff]').forEach(init));
})();

